// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","wrapper":"noProducts_wrapper__MM_qm","header":"noProducts_header__y1fCs","reset":"noProducts_reset__DqLU_"};